/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * EXPORTS
 */
export default gql`
mutation EntityUpdateMutation($input: [EntityUpdateInput!]!) {
  EntityUpdate(input: $input) {
    message
    status
  }
}
`
